import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import { Field as BaseField } from "@base-ui/react/field";
import clsx from "clsx";
import type { ReactNode } from "react";
import { Icon } from "../Icon/Icon";
import styles from "./Checkbox.module.css";

export interface CheckboxProps {
  label: ReactNode;
  description?: ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  /** The mixed state of a parent checkbox ("some rows selected"). */
  indeterminate?: boolean;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  value?: string;
  className?: string;
}

/** A labelled checkbox (Base UI Checkbox); the whole label row is clickable. */
export function Checkbox({
  label,
  description,
  checked,
  defaultChecked,
  onCheckedChange,
  indeterminate,
  disabled,
  required,
  name,
  value,
  className,
}: CheckboxProps) {
  return (
    <BaseField.Root name={name} disabled={disabled} className={clsx(styles.field, className)}>
      <BaseField.Label className={styles.label}>
        <BaseCheckbox.Root
          className={styles.box}
          checked={checked}
          defaultChecked={defaultChecked}
          onCheckedChange={onCheckedChange ? (next) => onCheckedChange(next) : undefined}
          indeterminate={indeterminate}
          required={required}
          value={value}
        >
          <BaseCheckbox.Indicator className={styles.indicator} keepMounted>
            <Icon name={indeterminate ? "minus" : "check"} />
          </BaseCheckbox.Indicator>
        </BaseCheckbox.Root>
        <span>{label}</span>
      </BaseField.Label>
      {description ? <BaseField.Description className={styles.description}>{description}</BaseField.Description> : null}
    </BaseField.Root>
  );
}
